module.exports = __webpack_public_path__ + "img/kewosi.11f25368.png";